var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m240 0c-132.546875 0-240 107.453125-240 240s107.453125 240 240 240 240-107.453125 240-240c-.148438-132.484375-107.515625-239.851562-240-240zm0 464c-123.710938 0-224-100.289062-224-224s100.289062-224 224-224 224 100.289062 224 224c-.140625 123.652344-100.347656 223.859375-224 224zm0 0","key":0}),React.createElement("path",{"d":"m352 144h-224c-4.417969 0-8 3.582031-8 8v176c0 4.417969 3.582031 8 8 8h224c4.417969 0 8-3.582031 8-8v-176c0-4.417969-3.582031-8-8-8zm-21.601562 16-90.398438 77.464844-90.398438-77.464844zm-194.398438 160v-150.609375l98.792969 84.679687c2.992187 2.5625 7.40625 2.5625 10.398437 0l98.808594-84.679687v150.609375zm0 0","key":1})]);
}

Email.defaultProps = {"height":"480pt","viewBox":"0 0 480 480","width":"480pt"};

module.exports = Email;

Email.default = Email;
